.form-wrapper {
  margin-top: calc(var(--spacer) * 1.5);
}

.myCompany-authentication-checkbox {
  width: auto;
  margin-bottom: var(--spacer);
  padding-right: 0;
}

.myCompany-authentication-section {
  max-width: 480px;
  display: block;
  align-items: center;
  padding-bottom: calc(var(--spacer) * 4);

  .myCompany-authentication-subsection {
    display: flex;
    width: 100%;
    flex-flow: column;
    align-items: flex-start;
    #twoFactorAuthCheckboxInfoText {
      margin-bottom: calc(var(--spacer) * 3);
    }
    #passwordAgeCheckboxInfoText {
      margin-bottom: calc(var(--spacer) * 2);
    }
    #skipTwoFactorAuthFormField {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    #skipTwoFactorAuthInfoText {
      margin-left: auto;
      max-width: 217px;
    }
  }
}

.myCompany-authentication-section-title {
  margin-bottom: calc(var(--spacer) * 2);

  .myCompany-authentication-ssoSamlKb-container {
    display: flex;
    align-items: center;
    margin-bottom: calc(var(--spacer) * 2);
  }

  .myCompany-authentication-section-text {
    width: auto;
  }

  #gravityZoneSamlKbUrl {
    padding-left: 5px;
  }
}

.form-label {
  display: flex;
  align-items: center;
  width: 40%;
  height: 30%;
}

.label-text {
  margin-bottom: 10px;
}

.subsection-title {
  color: var(--chart-300-icon-buttons);
  margin-bottom: calc(var(--spacer) * 2);
}
